var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglecloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 94,
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cac9c2",
    d: "M71.674 65.95l-10.84-18.776 10.84-18.776h21.68l10.84 18.776-10.84 18.776h-21.68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.876 55.744a8.46 8.46 0 0 1-8.45-8.45 8.46 8.46 0 0 1 8.45-8.449 8.46 8.46 0 0 1 8.449 8.449 8.46 8.46 0 0 1-8.449 8.45",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.875 22.103c-.665-1.15-2.295-2.092-3.624-2.092H69.537c-1.33 0-2.96.942-3.623 2.092l-7.806 13.52c-.06.873.1 1.786.484 2.453l5.284 9.034 9.432-16.295h29.813c.705 0 1.495.267 2.18.688l-5.427-9.4",
    fill: "#5072aa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.447 35.03l-.342.592c-.06.873.1 1.786.484 2.453l5.284 9.034 2.81-4.856-8.237-7.222",
    fill: "#4d6796"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.226 26.956c-.9-.001-1.63-.73-1.63-1.63s.73-1.63 1.63-1.63a1.63 1.63 0 0 1 1.63 1.63c-.001.9-.73 1.63-1.63 1.63zm26.714-1.63a1.51 1.51 0 0 1-2.27 1.323 1.51 1.51 0 0 1 .76-2.814 1.51 1.51 0 0 1 1.509 1.491z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.232 45.238l-7.93-13.736c-.686-.42-1.475-.687-2.18-.687H92.37l9.296 16.385-14.718 26.003c-.324.56-.878 1.07-1.514 1.447H96.25c1.33 0 2.96-.942 3.624-2.092l13.357-23.135c.665-1.15.665-3.033 0-4.184",
    fill: "#cc4232"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.66 32.118l-.356-.616c-.686-.42-1.475-.687-2.18-.687h-10.75l2.798 4.932 10.49-3.63",
    fill: "#b23f33"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.43 70.654c-.9-.001-1.63-.73-1.63-1.63s.73-1.63 1.63-1.63 1.63.73 1.63 1.63-.73 1.63-1.63 1.63m12.688-21.73c-.9-.001-1.63-.73-1.63-1.63s.73-1.63 1.63-1.63 1.63.73 1.63 1.63a1.63 1.63 0 0 1-1.63 1.63",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.514 63.588L58.592 38.076c-.385-.667-.545-1.58-.484-2.453l-5.55 9.615c-.664 1.15-.664 3.033 0 4.184l13.357 23.135c.664 1.15 2.295 2.092 3.623 2.092h15.898c.636-.376 1.2-.887 1.514-1.447l5.442-9.615H73.514",
    fill: "#ecb02a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.53 74.65h.925c.636-.376 1.2-.887 1.513-1.447l5.442-9.615h-5.795L84.53 74.65",
    fill: "#c79732"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.226 70.654c-.9-.001-1.63-.73-1.63-1.63s.73-1.63 1.63-1.63a1.63 1.63 0 1 1 0 3.261m-12.7-21.73c-.9-.001-1.63-.73-1.63-1.63s.73-1.63 1.63-1.63 1.63.73 1.63 1.63-.73 1.63-1.63 1.63",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglecloud);
export default __webpack_public_path__ + "static/media/Google cloud.4624552ae86f03e8f91c815d7653caf5.svg";
export { ForwardRef as ReactComponent };